<template>
  <div>
    <div class="annotate-container">
      <div class="annotate-title">
        <router-link :to="role === 'default' ? '/examlist' : '/tasklist'"
          ><button class="hollow-btn">返回</button></router-link
        >
        <button
          :style="{ background: mode === 0 || status === 'finish' ? '#cccccc' : '' }"
          @click="finishImage()"
          :disabled="status === 'finish'"
          style="width: 100px;margin-left: 30px;"
        >
          完成图片
        </button>
        <button
          v-if="status === 'finish'"
          @click="
            status = 'process';
            getNewImage();
          "
          style="width: 100px;margin-left: 30px;"
        >
          下一张
        </button>
        <span>图片ID：{{ imageId }}</span>
        <button
          v-if="status === 'finish' && (examType === 3 || examType === 1)"
          @click="showType = showType === 'wrong' ? 'all' : 'wrong'"
          style="width: 120px;position: absolute;right: 274px;"
        >
          {{ showType === 'wrong' ? '显示所有框' : '显示错误框' }}
        </button>
      </div>
      <div class="annotate-content">
        <div class="annotate-image">
          <AnnoPanel
            v-if="showPanel"
            :src="url"
            ref="annopanel"
            :annos="showType === 'all' ? annos : annos.filter(v => v.cat !== -1)"
            height="646"
            :style="{ height: '646px', background: '#fafafa' }"
            :mode="mode"
            scalable
            separable
            maskColor="transparent"
            @annoClick="annoClick($event)"
          ></AnnoPanel>
          <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
            <span>沪ICP备20000777号-1</span>
          </a>
        </div>
        <div class="annotate-classes anno-option">
          <div class="category-option" v-for="(item, group) of sortedClassifications" :key="group">
            <span
              class="class-option"
              :class="{ active: currClasses.includes(c.classId) }"
              v-for="c of item"
              :key="c.classId"
              @click="setClass(0, c.classId)"
            >
              {{ c.className }}
            </span>
            <div class="separate-line"></div>
          </div>
        </div>
        <div v-show="url" class="annotate-btn">
          <div v-show="mode === 1">
            <button @click="newAnno()">新增画框</button>
            <button class="hollow-btn disabled">无效</button>
          </div>
          <div v-show="mode === 0">
            <button :disabled="saveAnnoAble" @click="saveAnno()">保存画框</button>
            <button style="background: #c05d5d;" @click="deleteAnno()">
              {{ getDeleteName() }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnnoPanel from '@/components/AnnoPanel.vue';
import * as api from '@/api/api.js';
import { taskTypeMap } from '@/config';

export default {
  name: 'doexam',
  data: function() {
    return {
      showType: 'all',
      status: 'process',
      imageId: 0,
      url: '',
      currOperation: 'point',
      taskType: null, // AnnoPanel中的标注类型
      taskTypeId: null, // 服务端返回的标注类型
      taskTypeMap: {},
      annos: [], // 提交前用于保存标注的数组
      classifications: [],
      classes: [],
      mode: 1,
      currAnno: {},
      currClasses: [],
      width: 0,
      height: 0,
      saveAnnoAble: false,
      showPanel: true,
      sceneText: '',
      wordsIndex: 0,
      role: null,
      examType: null,
      examId: null,
    };
  },
  components: {
    AnnoPanel,
  },
  computed: {
    sortedClassifications() {
      return this.classifications.reduce((pre, cur) => {
        cur.classes.forEach(v => {
          const group = parseInt(v.groupId / 100);
          if (pre[group]) {
            pre[group].push(v);
          } else {
            pre[group] = [v];
          }
        });
        return pre;
      }, {});
    },
  },
  mounted: function() {
    this.role = this.$store.state.role;
    this.examType = parseInt(this.$route.params.examtype);
    this.examId = parseInt(this.$route.params.examid);
    this.taskTypeMap = taskTypeMap;
    if (this.examId === -1) {
      api.startTaskExam(this.$route.query.tid).then(res => {
        this.classes = res.data.classes;
        this.classifications = [{ classes: res.data.classes }];
        this.getNewImage();
      });
    } else {
      api.startExam(this.$route.params.examid).then(res => {
        this.classes = res.data.classes;
        this.classifications = [{ classes: res.data.classes }];
        this.getNewImage();
      });
    }
  },
  methods: {
    getDeleteName() {
      return this.$refs.annopanel && this.$refs.annopanel.getPainter().id ? '删除' : '取消';
    },
    getNewImage() {
      if (this.examId === -1) {
        api
          .getTaskExamImage(this.$route.query.tid)
          .then(res => {
            if (!res.data.id) {
              alert('练习题已全部完成');
              this.status = 'finish';
              return;
            }
            this.status = 'process';
            this.imageId = res.data.id;
            this.url = res.data.url;
            this.height = res.data.height;
            this.width = res.data.width;
            this.showPanel = true;
            this.mode = 1;
            this.currClasses = [];
            this.currAnno = {};
            this.annos = [];
          })
          .catch(err => {
            window.console.log('error:', err);
            this.url = '';
            this.currAnno = {};
            this.currClasses = [];
            this.annos = [];
          });
      } else {
        api
          .getExamImage(this.$route.params.examid)
          .then(res => {
            if (!res.data.id) {
              alert('测试题已全部完成');
              this.status = 'finish';
              return;
            }
            this.status = 'process';
            this.imageId = res.data.id;
            this.url = res.data.url;
            this.height = res.data.height;
            this.width = res.data.width;
            this.showPanel = true;
            this.mode = 1;
            this.taskTypeId = res.data.task_type_id;
            this.currClasses = [];
            this.currAnno = {};
            this.annos = [];
          })
          .catch(err => {
            window.console.log('error:', err);
            this.url = '';
            this.currAnno = {};
            this.currClasses = [];
            this.annos = [];
          });
      }
    },
    finishImage() {
      if (this.mode === 1) {
        let tmpFormatAnnos = this.annos.map(v => ({ id: v.id, points: v.data, classIds: v.classIds }));
        api
          .finishExamImage(this.$route.params.examid, this.imageId, {
            annotations: tmpFormatAnnos,
            taskId: this.$route.query.tid,
          })
          .then(res => {
            let resAnnos = res.data;
            resAnnos.correct.forEach(v => {
              v.cat = -1;
              v.title = `正确；${this.classes.find(cls => cls.classId === v.classIds[0]).className}`;
            });
            resAnnos.clswrong.forEach(v => {
              v.cat = -2;
              v.title = `类别错误；正确类别：${this.classes.find(cls => cls.classId === v.classIds[0]).className}`;
            });
            resAnnos.missing.forEach(v => {
              v.cat = -3;
              v.title = `漏框；${this.classes.find(cls => cls.classId === v.classIds[0]).className}`;
            });
            resAnnos.redundant.forEach(v => {
              v.cat = -4;
              v.title = `多框；${this.classes.find(cls => cls.classId === v.classIds[0]).className}`;
            });
            let errCnt = resAnnos.clswrong.length + resAnnos.missing.length + resAnnos.redundant.length;
            if (errCnt > 0)
              this.$notify({
                group: 'foo',
                text: `存在${errCnt}处错误`,
                type: 'custom-red',
                duration: 1500,
              });
            else
              this.$notify({
                group: 'foo',
                text: `全部正确`,
                type: 'custom-blue',
                duration: 1500,
              });
            this.annos = [];
            if (this.examType === 3 || this.examType === 1) {
              this.annos = [].concat(resAnnos.correct, resAnnos.clswrong, resAnnos.missing, resAnnos.redundant);
            } else {
              this.annos = [].concat(resAnnos.correct, resAnnos.clswrong, resAnnos.redundant);
            }
            this.annos.forEach(v => {
              v.type = this.taskTypeMap[this.taskTypeId];
              v.data = v.points;
            });
            this.status = 'finish';
          })
          .catch(() => {});
      }
    },
    newAnno() {
      this.$refs.annopanel.setPainter({
        type: this.taskTypeMap[this.taskTypeId],
        data: [[]],
      });
      this.mode = 0;
    },
    saveVerification() {
      // 通用检测
      if (this.currAnno.data.some(v => v.some(v => Math.round(v[0]) > this.width || Math.round(v[1]) > this.height))) {
        this.$notify({
          group: 'foo',
          text: '有标注点无法保存，请删除',
          type: 'custom-red',
          duration: 1500,
        });
        return false;
      }
      // 类别选择检测(除了taskTypeId===5的)
      if (Object.keys(this.currClasses).length !== this.classifications.length) {
        this.$notify({
          group: 'foo',
          text: '类别未选择完整',
          type: 'custom-red',
          duration: 1500,
        });
        return false;
      }
      // 根据AnnoPanel组件里的标注类别判断 点数和最小面积
      if (this.currAnno.type === 3) {
        if (!this.currAnno.data.every(v => v.length > 2)) {
          this.$notify({
            group: 'foo',
            text: '多边形点数应不少于3，请确认',
            type: 'custom-red',
            duration: 1500,
          });
          return false;
        }
      }
      return true;
    },
    saveAnno() {
      this.currAnno = this.$refs.annopanel.getPainter();
      if (!this.saveVerification()) return;
      this.saveAnnoAble = true;
      this.currAnno.data = this.currAnno.data.map(v => v.map(v => v.map(v => Math.round(v))));
      if (!this.currAnno.id) {
        this.addAnno();
      } else {
        this.updateAnno();
      }
    },
    addAnno() {
      let id = this.annos.length + 1;
      this.annos.push({
        id,
        data: this.currAnno.data,
        classIds: this.currClasses,
        type: this.taskTypeMap[this.taskTypeId],
        cat: this.currClasses[0],
        title: this.classes.find(cls => cls.classId === this.currClasses[0]).className,
      });
      this.mode = 1;
      this.currClasses = [];
      this.currAnno = {};
      this.saveAnnoAble = false;
    },
    updateAnno() {
      this.annos.find(v => v.id === this.currAnno.id).data = this.currAnno.data;
      this.annos.find(v => v.id === this.currAnno.id).classIds = this.currClasses;
      this.annos.find(v => v.id === this.currAnno.id).title = this.classes.find(
        cls => cls.classId === this.currClasses[0],
      ).className;
      this.mode = 1;
      this.currClasses = [];
      this.currAnno = {};
      this.saveAnnoAble = false;
    },
    deleteAnno() {
      this.annos = this.annos.filter(v => v.id !== this.currAnno.id);
      this.mode = 1;
      this.currClasses = [];
      this.currAnno = {};
    },
    setClass(index, classId) {
      if (this.mode === 0) {
        this.$set(this.currClasses, index, classId);
      }
    },
    annoClick: function(annoId) {
      this.currAnno = this.annos.find(v => v.id === annoId);
      this.$refs.annopanel.setPainter(this.currAnno);
      this.currClasses = this.currAnno.classIds;
      this.mode = 0;
    },
  },
};
</script>
<style scoped>
button {
  margin: 0px;
  height: 38px;
}
button.active {
  background-color: #5d89c0;
  color: #ffffff;
}
.mode-btn {
  display: inline-block;
  float: right;
  margin-right: 224px;
}
.mode-btn button {
  margin-left: 20px;
  width: 100px;
  outline: none;
}
.annotate-btn {
  position: absolute;
  right: 0px;
  bottom: 12px;
}
.annotate-btn div button:first-child {
  width: 100px;
  margin-right: 40px;
}
.annotate-btn div button:last-child {
  width: 60px;
}
.annotate-content {
  height: 646px;
  position: relative;
}
.annotate-image {
  box-sizing: border-box;
  margin-right: 224px;
}
.anno-option {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 200px;
  height: 588px;
  padding-top: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background: #fafafa;
  overflow: scroll;
}
.annotate-text {
  padding: 0px;
}
.annotate-text textarea {
  resize: none;
  width: 198px;
  height: 586px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 18px;
}
.annotate-container {
  padding: 0px 50px 24px;
  width: 100%;
  box-sizing: border-box;
}
.annotate-title {
  margin: 16px 0px;
}
.annotate-title span {
  margin-left: 25%;
}
.annotate-title button {
  /*width: 120px;*/
  height: 30px;
}
.class-option {
  display: block;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 14px;
}
.class-option.active {
  background: rgba(93, 137, 192, 0.3);
}
.category-option:last-child .separate-line {
  display: none;
}
.separate-line {
  border-top: 1px dashed #bbbbbb;
  margin: 6px;
}
.icp-info {
  display: block;
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
.hollow-btn.disabled {
  color: #999;
  border-color: #999;
}
</style>
